<template>
  <Navbar :center-text="$t('FarmerAdviceView.farmerAdvice')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <form class="container mt-5 mb-5 w-100">
    <div class="row mb-4 justify-content-center">
      <div class="col-md-6 col-sm-12 form-group">
        <label for="farmer"
               class="form-label">
          {{ $t('farmerID') }}
        </label>
        <multiselect placeholder=""
                     v-model="selectedFarms"
                     :options="availableFarms"
                     :custom-label="selectLabel"
                     :multiple="true"
                     :searchable="true"
                     :close-on-select="true"
                     :clear-on-select="true"
                     :show-labels="false"
                     :preselect-first="true"
                     track-by="__id"
                     required></multiselect>
      </div>
    </div>
    <div class="row mb-4 justify-content-center">
      <div class="col-md-3 col-sm-12">
        <label for="start-date"
               class="form-label">
          {{ $t('startDate') }}
        </label>
        <input
            id="start-date"
            type="date"
            class="form-control rounded-pill"
            v-model="startDate"
        />
      </div>
      <div class="col-md-3 col-sm-12">
        <label for="end-date"
               class="form-label">
          {{ $t('endDate') }}
        </label>
        <input
            id="end-date"
            type="date"
            class="form-control rounded-pill"
            v-model="endDate"/>
      </div>

      <div v-if="showErrorTimespan" class="text-danger mt-1">
        {{ $t('selectValidTimespan') }}
      </div>
    </div>
  </form>

  <div class="container mb-4 w-100" v-if="visits.length > 0">
    <FileExport :filename="this.exportFilename"
                :data="this.exportData">
    </FileExport>

    <table class="table table-striped table-hover">
      <thead>
      <tr>
        <th>{{ $t('date') }}</th>
        <th>{{ $t('farmerID') }}</th>
        <th>{{ $t('mainActivities') }}</th>
        <th>{{ $t('mainResults') }}</th>
        <th>{{ $t('observations') }}</th>
        <th>{{ $t('downloadPicture') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="visit in visits">
        <td class="text-start">
          <i class="bi bi-calendar-date"></i>&nbsp;{{ visit.date }}<br/>
          <i class="bi bi-clock"></i>&nbsp;{{ new Date("1970-01-01T" + visit.time_start).toLocaleTimeString() }} -
          {{ new Date("1970-01-01T" + visit.time_finish).toLocaleTimeString("de-DE") }}
        </td>
        <td>{{ visit.farmer_code }}</td>
        <td class="text-start">{{ visit.activities }}</td>
        <td class="text-start">{{ visit.results }}</td>
        <td class="text-start">{{ visit.comments }}</td>
        <td>
          <button class="m-0 btn btn-sm btn-success"
                  v-if="visit.picture"
                  style="min-width:100px;"
                  @click="downloadPicture(visit.KEY)">
            <i class="bi bi-download"></i>{{ $t('downloadPicture') }}
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <Footerbar></Footerbar>
</template>

<script>

import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import {sharedState} from "@/store";
import Multiselect from "vue-multiselect";
import {getFarmsForUser, getAllFarmVisits, getVisitPicture, getAllUsers} from "@/utils";
import FileExport from "@/components/FileExport.vue";

export default {
  data() {
    return {
      sharedState,
      message: null,
      messageType: null,
      startDate: "",
      endDate: "",
      showErrorTimespan: false,
      availableUsers: [],
      availableFarms: [],
      selectedFarms: [],
      visits: [],
      exportFilename: '',
      exportData: '',
    }
  },
  components: {
    FileExport: FileExport,
    Multiselect,
    Footerbar,
    Navbar,
  },
  async mounted() {
    this.endDate = new Date().toISOString().slice(0, 10);
    this.startDate = new Date();
    this.startDate.setFullYear(this.startDate.getFullYear() - 1);
    this.startDate = this.startDate.toISOString().slice(0, 10);

    let response = await getFarmsForUser(sharedState.user_id);
    if (response.status === 200) {
      this.availableFarms = response.data;
    } else if(response.status === 204) {
      this.availableUsers = [];
    } else {
      this.message = response.response.data.message;
      this.messageType = "danger";
    }

    let userResponse = await getAllUsers();
    if (userResponse.status === 200) {
      this.availableUsers = userResponse.data;
    } else {
      this.message = userResponse.response.data.message;
      this.messageType = "danger";
    }
  },
  methods: {
    selectLabel({__id, label}) {
      return `${label}`
    },
    async getVisits() {
      let farms = this.selectedFarms.map((farm) => farm.__id);
      let response = await getAllFarmVisits(sharedState.user_id, farms, this.startDate, this.endDate);
      if (response.status === 200) {
        this.visits = response.data;
        this.visits.forEach((visit) => {
          visit.farmer_code = this.availableFarms.find(farm => {
            return farm.__id === visit.farmer;
          })['label'];
        });

        this.visits.forEach((visit) => {
          visit.advisor_label = this.availableUsers.find(user => {
            return user.id === visit.advisor;
          })['label'];
        });


        this.exportFilename = this.endDate + "-CANALLS-Farmer_advice_visits"
        const filteredVisits = this.visits.map(({
                                                  SubmissionDate,
                                                  intro,
                                                  date,
                                                  geopoint_Latitude,
                                                  geopoint_Longitude,
                                                  geopoint_Altitude,
                                                  geopoint_Accuracy,
                                                  advisor,
                                                  advisor_label,
                                                  confirm_registration,
                                                  farmer,
                                                  farmer_code,
                                                  exclamation,
                                                  purpose,
                                                  other_purpose,
                                                  activities,
                                                  time_start,
                                                  time_finish,
                                                  participants_men,
                                                  participants_women,
                                                  results,
                                                  actions_totake,
                                                  self_assess_visit,
                                                  comments,
                                                  picture,
                                                  meta_instanceID,
                                                  KEY,
                                                  SubmitterID,
                                                  SubmitterName,
                                                  AttachmentsPresent,
                                                  AttachmentsExpected,
                                                  Status,
                                                  ReviewState,
                                                  DeviceID,
                                                  Edits,
                                                  FormVersion
                                                }) =>
            ({
              date,
              advisor_label,
              farmer_code,
              purpose,
              other_purpose,
              activities,
              time_start,
              time_finish,
              participants_men,
              participants_women,
              results,
              actions_totake,
              self_assess_visit,
              comments,
            })
        );
        this.exportData = filteredVisits;
      } else if (response.status === 204) {
        this.visits = [];
      } else {
        this.visits = [];
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    },
    async downloadPicture(visitId) {
      let response = await getVisitPicture(visitId);
      if (response.status === 200) {
        const url = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'CANALLS-Farmer_advice_visit_' + visitId + '.jpg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    },
  },
  watch: {
    async selectedFarms(newVal, oldVal) {
      if (newVal.length === 0 || this.showErrorTimespan) {
        this.visits = [];
      } else if (this.availableFarms.length > 0) {
        await this.getVisits();
      }
    },
    async startDate(newVal, oldVal) {
      if (Date.parse(newVal) >= Date.parse(this.endDate)) {
        this.message = this.$t('selectValidTimespan');
        this.messageType = "danger";
        this.visits = [];
      } else {
        this.message = '';
        this.messageType = ''
        if (this.availableFarms.length > 0) {
          await this.getVisits();
        }
      }
    },
    async endDate(newVal, oldVal) {
      if (Date.parse(newVal) <= Date.parse(this.endDate)) {
        this.message = this.$t('selectValidTimespan');
        this.messageType = "danger";
        this.visits = [];
      } else {
        this.message = '';
        this.messageType = ''
        if (this.availableFarms.length > 0) {
          await this.getVisits();
        }
      }
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
